module.exports = __webpack_public_path__ + "static/media/4-actual.843abe42.jpg";